<template>
  <div class="outerbox headbox" ref="headbox">
    <!-- 整体外层 -->
    <div class="innercoreversion content">
      <!-- <h1>亿大师</h1> -->
      <img src="../image/logohome.png" width="149px" height="44px" alt="宇亿润宸网络科技（深圳）有限公司" />
      <!-- 版心位置 -->
      <div class="grairight">
        <div class="nowlist">
          <!-- 需要调准的地方 -->
          <a href="#header">首页 </a>
          <a href="#product"
            >产品服务
            <!-- <img width="16px" height="16px" style="vertical-align: text-bottom" src="../image/morehave.png" alt="" /> -->
          </a>
          <a href="#IndustrySolutions">行业方案</a>
          <a href="#success"
            >成功案例
            <!-- <img width="16px" height="16px" style="vertical-align: text-bottom" src="../image/morehave.png" alt="" /> -->
          </a>
          <a href="#about">关于我们</a>
        </div>
        <a href="#about" class="nowgohave">立即体验</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadBox',
  mounted() {
    // window.addEventListener('scroll', function () {
    //   // 获取滚动的距离
    //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   // 根据滚动位置执行一些操作
    //   if (scrollTop > 0) {
    //   }
    // })
    //将class为headbox的盒子，当窗口滚动后让盒子背景颜色便曾rgba(0,0,0,0.5)
    window.addEventListener('scroll', function () {
      const headbox = document.querySelector('.headbox')
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 80) {
        headbox.style.backgroundColor = 'rgba(0,0,0,0.5)'
        headbox.style.border = '1px solid rgba(0,0,0,0.5)'
      } else {
        headbox.style.backgroundColor = 'rgba(0,0,0,1)'
        headbox.style.border = '1px solid rgba(0,0,0,1)'
      }
    })
  },
  data() {
    return {
      count: 100,
    }
  },
}
</script>

<style lang="less" scoped>
.headbox {
  height: 60px;
  background: #000000;
  border: 1px solid #000000;
  .content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .grairight {
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      .nowlist {
        a:hover {
          color: #0a5fc0;
        }
        & > a:active {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff; /* 激活时的颜色 */
          transform: scale(0.95); /* 点击时缩小 */
        }
        & > a {
          padding: 16px;
        }
      }

      .nowgohave {
        margin-left: 32px;
        text-align: center;
        line-height: 46px;
        width: 120px;
        height: 46px;
        background: #57cc9a;
        border-radius: 44px 44px 44px 44px;
      }
    }
  }
}
.onbigimg {
  height: 500px;
  background-color: #57cc9a;
}
</style>